import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_3: FaireProductEntity = {
  token: "legacy_prod_abbott-3",
  type: "product",
  name: "Green LED Pillar Candle 2x4 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e8e445fce553dac53590ad93bf646ad01de263137e6e30cb79c6bf01ec37b13a.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
